import { usePagination } from 'react-instantsearch';
import { useRouter } from 'next/router';

//* Components
import CustomPagination from 'components/common/Pagination';
import Icon from 'components/common/Icon';

const Pagination = ({ perPage, totalHits }) => {
	const { currentRefinement, refine } = usePagination({ itemPerPage: perPage });
	const router = useRouter();

	const currentPage = Number(router.query.page || currentRefinement + 1);

	const onPaginationChange = (_, page) => {
		// Convert 1-based page to 0-based for Algolia
		refine(page - 1);

		// Update URL with current page
		const query = { ...router.query };
		if (page > 1) {
			query.page = page.toString();
		} else {
			delete query.page;
		}

		router.replace(
			{
				pathname: router.pathname,
				query,
			},
			undefined,
			{ shallow: true }
		);

		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	};

	return (
		<CustomPagination
			total={totalHits}
			pageSize={perPage}
			pageNumbersToShow={5}
			currentRefinement={currentPage}
			nextIcon={<Icon name='arrow-small' />}
			prevIcon={<Icon name='arrow-small' />}
			onCategoryChange={onPaginationChange}
		/>
	);
};

export default Pagination;
